import {NavigationPointerContainer } from './navigationpointer.styles'; 
import Pointer from '../Pointer';

const NavigationPointer = ({show}) => (
    <NavigationPointerContainer>
        <Pointer show ={show}/>
    </NavigationPointerContainer>
)

export default NavigationPointer; 